import { clearAgreementPdfCache } from '../../../lib/agreement-pdf-cache';
import { clearH5TokenAfterNewOpen, isH5User, userState } from '../../../stores/user';
import { clearSzcaCertCache, clearSzcaPendingState } from '../account/open-progress/on-line/risk/szca-face';

/** 清开户步骤缓存（避免拉入 open-progress/store） */
const clearOpenProgressStepCache = () => {
  try {
    const uid = userState.id || 'anon';
    localStorage.removeItem(`open_progress_step_${uid}`);
    if (uid !== 'anon') localStorage.removeItem('open_progress_step_anon');
  } catch {
    /* ignore */
  }
};

/**
 * H5 开户 / 加开户：退出流程 → 清相关本地缓存与 token，并打开登录页。
 * App WebView 不处理。
 */
export const exitH5OpenAccountFlow = () => {
  if (!isH5User()) return;
  clearOpenProgressStepCache();
  clearSzcaPendingState();
  clearSzcaCertCache();
  clearAgreementPdfCache();
  clearH5TokenAfterNewOpen();
};
